import { useTranslation } from 'react-i18next';
import { Form } from '@anytag/shared-atoms';
import { useFormContext } from 'react-hook-form';
import {
  NameField,
  EmailField,
  ReasonField,
  CountryField,
  GendersField,
  IntroduceField,
  PhoneNumberField,
  DateOfBirthField,
  RegionAndProvinceField,
  InfluencerCategoriesField
} from '../../shared';
import { TalentInfluencerFormValues } from '../schema-types';

export const InfluencerAccountSection = () => {
  const { t } = useTranslation();
  const { watch } = useFormContext<TalentInfluencerFormValues>();

  const values = watch();
  const influencerId = values?.id;

  return (
    <>
      <Form.SectionTitle className="mt-8 mb-0" label={t('Influencer Account')} />

      <NameField required />

      <Form.Fields itemsPerRow={2}>
        <InfluencerCategoriesField required />
        <GendersField required />
        <CountryField disabled={!!influencerId} hasAllAvailableCountries required />
        <RegionAndProvinceField regionFieldProps={{ required: true }} />
        <EmailField required />
        <PhoneNumberField />
      </Form.Fields>

      <DateOfBirthField required />
      <IntroduceField />
      <ReasonField />
    </>
  );
};
